import { render, staticRenderFns } from "./TeachingList.vue?vue&type=template&id=54912436"
import script from "./TeachingList.vue?vue&type=script&lang=js"
export * from "./TeachingList.vue?vue&type=script&lang=js"
import style0 from "./TeachingList.vue?vue&type=style&index=0&id=54912436&prod&lang=scss&scopted=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports